import React from "react";
import InternalHeader from "~/components/Layout/components/InternalHeader";
import { useLang } from "~/hooks/useLang";
import ListAllAuditUsersReport from "./components/ListAllAuditUsersReport";

export default function AuditUsersReportTable() {
    const { translate } = useLang();
    
    return (
        <>
            <InternalHeader title={`${translate('Audit')}: ${translate('Users')}`} />
            <ListAllAuditUsersReport />
        </>
    )
}